<template>
    <main>
        <section class="hero">
            <div class="lg:tw-container tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-items-center lg:tw-flex-row lg:tw-justify-between">
                <div class="info-container tw-relative tw-flex tw-justify-center tw-items-center lg:tw-justify-start lg:tw-items-start lg:tw-flex-col">
                    <div>
                        <img src="~@/assets/img/logo.svg" alt="Intracic" class="lg:tw-hidden logo-img tw-mx-auto">
                        <h1>Tem ou conhece alguém com dificuldades em ouvir os seus familiares, ouvir TV ou Rádio?</h1>
                        <h2>O revolucionário <b>Aparelho Auditivo</b><br><b>Digital INTRACIC</b> é a solução ideal para si!</h2>
                    </div>
                    <div class="tw-hidden lg:tw-block">
                        <img src="~@/assets/img/hero.png" class="hero-img">
                        <small>*Oferta limitada às primeiras 300 respostas.</small>
                    </div>
                </div>
                <div class="form-container">
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" />
                </div>
            </div>
        </section>
        <section class="grid tw-py-10">
            <div class="tw-container">
                <div class="tw-grid tw-grid-cols-1 tw-gap-10 lg:tw-grid-cols-3">
                    <div>
                        <div class="image">
                            <img src="~@/assets/img/icons/bullet-01.svg">
                        </div>
                        <div class="text">
                            <h3>3 vezes mais potência</h3>
                            <p>A nitidez do mais recente software SmartFocus, aumenta a clareza do discurso e filtra os ruídos de fundo em ambientes ruidosos.</p>
                        </div>
                    </div>
                    <div>
                        <div class="image">
                            <img src="~@/assets/img/icons/bullet-02.svg">
                        </div>
                        <div class="text">
                            <h3>Volte a ouvir a TV e a Rádio</h3>
                            <p>Inclui definições de memorização de música e de TV, de modo a maximizar a qualidade de som e o seu prazer de audição.</p>
                        </div>
                    </div>
                    <div>
                        <div class="image">
                            <img src="~@/assets/img/icons/bullet-03.svg">
                        </div>
                        <div class="text">
                            <h3>Volte a conversar ao telefone</h3>
                            <p>Oiça facilmente as conversas telefónicas, sem perder uma palavra. Volte a conversar com os seus familiares e amigos à distância.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="slider-container tw-py-10">
            <div class="glide main__slider tw-relative tw-w-full">
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides tw-flex" v-if="sliderContent.length">
                        <li class="glide__slide tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-gap-5 lg:tw-items-start lg:tw-flex-row" v-for="(content, index) in sliderContent" :key="index">
                            <div class="photo">
                                <img :src="`img/${content.photo}.png`">
                            </div>
                            <div class="text">
                                <p v-html="content.text"></p>
                                <h4 v-html="content.title"></h4>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- Glide Arrows -->
                <div class="glide__arrows tw-absolute" data-glide-el="controls">
                    <button class="glide__arrow glide__arrow--prev" data-glide-dir="<"><img src="~@/assets/img/icons/arrow-sliders.svg"></button>
                    <button class="glide__arrow glide__arrow--next" data-glide-dir=">"><img src="~@/assets/img/icons/arrow-sliders.svg"></button>
                </div>
            </div>
        </section>
        <section class="try tw-py-10">
            <div class="tw-container">
                <div class="tw-flex tw-flex-col tw-justify-center tw-items-center lg:tw-flex-row lg:tw-justify-between">
                    <h2 class="tw-text-center lg:tw-text-left">Sabia que mais de 500 milhões de pessoas têm algum grau de perda auditiva?<br><span>Melhore a sua audição!</span></h2>
                    <button class="btn-page" v-scroll-to="'.hero'">Experimente Grátis ></button>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import Glide, {
Autoplay, Controls, Swipe, Breakpoints,
} from '@glidejs/glide/dist/glide.modular.esm';
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
    data() {
        return {
            sliderContent: [
                { photo: 'person1', text: '“Agora até ponho a TV baixinha. Tem aqui um canário que é do vizinho de baixo e que eu mal ouvia quando ia passear o cão e agora ouço-o bem! Até parece um papagaio! (risos) Dá gosto ouvi-lo cantar.”', title: 'José A. - Viana do Castelo 66 anos' },
                { photo: 'person2', text: '“Nunca deixei chegar a um ponto em que a minha audição falhasse por completo. Preveni-me a tempo e acho que foi o que fiz melhor.”', title: 'António V. - Braga 82 anos' },
                { photo: 'person3', text: '“Como eu tive uma «má experiência» a primeira vez que experimentei aparelhos auditivos porque apitavam muito, fui adiando voltar a experimentar. Mas agora está tudo diferente. Não tenho palavras para descrever. Oxalá todas as pessoas pudessem experimentar.”', title: 'Maria S. - Viana do Castelo 64 anos' },
            ],
        };
    },
    mounted() {
        new Glide('.main__slider', {
            type: 'carousel',
            gap: 0,
            startAt: 0,
            perView: 1,
            peek: 0,
            breakpoints: {
                768: {
                    perView: 1,
                    autoplay: 5000,
                },
            },
        }).mount({
            Controls, Autoplay, Swipe, Breakpoints,
        });
    },
};
</script>
